/**
 * @description : Currency Symbol
 * @author : vineela
 * @date : 26-09-2026
 * */
import React from 'react';

function CurrencySymbol(props) {
  const cur = props.currency;
  const containerStyle = {
    '--currency--symbol': props.currencysymbol || ' (₹)',
  };

  return (
    <span className="cur" style={containerStyle}>
      {cur}
    </span>
  );
}
export default CurrencySymbol;
